// src/data/mockRoadmaps.js

import TechGif from '../../assets/icons/tech.gif';
import BusinessGif from '../../assets/icons/business.gif';
import MedicalGif from '../../assets/icons/medical.gif';
import CreativeGif from '../../assets/icons/creative.gif';
import ContentGif from '../../assets/icons/content.gif';
import SportsGif from '../../assets/icons/sports.gif';
import TradesGif from '../../assets/icons/trades.gif'; 
import EducationGif from '../../assets/icons/education.gif';
import EnvironmentalGif from '../../assets/icons/environmental.gif';
import CulinaryGif from '../../assets/icons/culinary.gif';
import LawGif from '../../assets/icons/law.gif';

const toSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/ & /g, '')
    .replace(/ /g, '-')
    .replace(/[^a-z0-9-]/g, '');
};

const PATH_ROADMAPS = {

  // 1. TECHNOLOGY & SOFTWARE
  [toSlug('Technology & Software')]: {
    title: 'Technology & Software',
    fullTitle: 'Technology & Software Roadmap',
    description: 'Learn programming, web development, cloud computing, and software engineering best practices.',
    icon: TechGif,
    resources: [
        {
          title: 'FreeCodeCamp Full Stack Curriculum',
          description: 'Industry-recognized full-stack curriculum covering HTML, CSS, JavaScript, React, Node, and databases.',
          type: 'course',
          url: 'https://www.freecodecamp.org/learn',
          duration: '300+ hours'
        },
        {
          title: 'CS50: Introduction to Computer Science',
          description: 'Harvard’s introduction to computer science and programming.',
          type: 'course',
          url: 'https://cs50.harvard.edu/x/',
          duration: '12 weeks'
        },
        {
          title: 'AWS Cloud Practitioner Essentials',
          description: 'Learn the fundamentals of AWS cloud services.',
          type: 'course',
          url: 'https://explore.skillbuilder.aws/learn/course/134/aws-cloud-practitioner-essentials',
          duration: '6 hours'
        },
        {
          title: 'Google IT Automation with Python',
          description: 'Automate tasks and enhance productivity using Python.',
          type: 'course',
          url: 'https://www.coursera.org/professional-certificates/google-it-automation',
          duration: '6 months'
        },
        {
          title: 'The Odin Project',
          description: 'Open-source curriculum for full-stack web development.',
          type: 'course',
          url: 'https://www.theodinproject.com',
          duration: 'Self-paced'
        },
        {
          title: 'MDN Web Docs',
          description: 'Authoritative documentation for HTML, CSS, and JavaScript.',
          type: 'website',
          url: 'https://developer.mozilla.org/',
          duration: null
        },
        {
          title: 'System Design Primer',
          description: 'Learn how to design scalable systems.',
          type: 'website',
          url: 'https://github.com/donnemartin/system-design-primer',
          duration: null
        }
      ],
      
      articles: [
        {
          title: 'Frontend vs Backend vs Full Stack',
          description: 'Breakdown of software development career paths.',
          type: 'article',
          url: 'https://www.coursera.org/articles/front-end-vs-back-end-vs-full-stack',
          duration: '10 min read'
        },
        {
          title: 'What Is REST API?',
          description: 'Beginner-friendly explanation of RESTful APIs.',
          type: 'article',
          url: 'https://www.redhat.com/en/topics/api/what-is-a-rest-api',
          duration: '8 min read'
        },
        {
          title: 'How to Become a Software Engineer',
          description: 'Step-by-step roadmap from beginner to professional.',
          type: 'article',
          url: 'https://www.freecodecamp.org/news/how-to-become-a-software-engineer/',
          duration: '12 min read'
        },
        {
          title: 'What Is Cloud Computing?',
          description: 'Intro to cloud services, infrastructure, and benefits.',
          type: 'article',
          url: 'https://azure.microsoft.com/en-us/resources/cloud-computing-dictionary/what-is-cloud-computing/',
          duration: '7 min read'
        },
        {
          title: 'Monolith vs Microservices',
          description: 'Understanding backend architecture decisions.',
          type: 'article',
          url: 'https://www.atlassian.com/microservices/microservices-architecture',
          duration: '9 min read'
        },
        {
          title: 'Junior Developer Resume Guide',
          description: 'How to land your first developer role.',
          type: 'article',
          url: 'https://www.freecodecamp.org/news/developer-resume-get-hired/',
          duration: '10 min read'
        }
      ],
      
      videos: [
        {
          title: 'React JS Full Course',
          description: 'Beginner-to-advanced React tutorial.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=bMknfKXIFA8',
          duration: '11 hours'
        },
        {
          title: 'Node.js Crash Course',
          description: 'Learn backend development using Node.js.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=fBNz5xF-Kx4',
          duration: '1.5 hours'
        },
        {
          title: 'How I Would Learn to Code Today',
          description: 'Advice from a senior engineer on learning efficiently.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=66tfvFeALBQ',
          duration: '14 min'
        },
        {
          title: 'System Design Basics',
          description: 'Intro to designing scalable systems.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=MbjObHmDbZo',
          duration: '30 min'
        },
        {
          title: 'Day in the Life of a Software Engineer',
          description: 'Realistic look at software engineering work.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=4yxxS-2cbY8',
          duration: '12 min'
        },
        {
          title: 'Backend Developer Roadmap',
          description: 'What technologies backend developers should learn.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=p4McqzR5gKw',
          duration: '20 min'
        }
      ],
      
  },

  // 2. BUSINESS & ENTREPRENEURSHIP
  [toSlug('Business & Entrepreneurship')]: {
    title: 'Business & Entrepreneurship',
    fullTitle: 'Business & Entrepreneurship Path',
    description: 'Build skills in finance, startups, marketing, and leadership.',
    icon: BusinessGif,
    resources: [
        {
          title: 'Entrepreneurship Specialization – Wharton',
          description: 'Learn opportunity analysis, marketing, and growth strategies.',
          type: 'course',
          url: 'https://www.coursera.org/specializations/entrepreneurship',
          duration: '6 months'
        },
        {
          title: 'Small Business Guide – SBA',
          description: 'Official U.S. government guide for startups and small businesses.',
          type: 'website',
          url: 'https://www.sba.gov/business-guide',
          duration: null
        },
        {
          title: 'Y Combinator Startup School',
          description: 'Free startup education from top founders and investors.',
          type: 'course',
          url: 'https://www.startupschool.org/',
          duration: 'Self-paced'
        },
        {
          title: 'Google Digital Garage – Fundamentals of Digital Marketing',
          description: 'SEO, ads, analytics, and online business fundamentals.',
          type: 'course',
          url: 'https://learndigital.withgoogle.com/digitalgarage/course/digital-marketing',
          duration: '40 hours'
        },
        {
          title: 'Financial Modeling for Startups',
          description: 'Build financial projections and investor-ready models.',
          type: 'course',
          url: 'https://www.coursera.org/learn/wharton-finance-accounting',
          duration: '4 weeks'
        },
        {
          title: 'Product Hunt',
          description: 'Discover startups, launch products, and learn market demand.',
          type: 'website',
          url: 'https://www.producthunt.com/',
          duration: null
        },
        {
          title: 'Stripe Atlas Guides',
          description: 'Legal, tax, and operational guides for startups.',
          type: 'website',
          url: 'https://stripe.com/atlas/guides',
          duration: null
        }
      ],
      
      articles: [
        {
          title: 'How to Write a Business Plan',
          description: 'Step-by-step business plan guide.',
          type: 'article',
          url: 'https://www.investopedia.com/articles/personal-finance/010815/how-write-business-plan.asp',
          duration: '12 min read'
        },
        {
          title: 'Bootstrapping vs Venture Capital',
          description: 'Understanding funding options for startups.',
          type: 'article',
          url: 'https://www.forbes.com/advisor/business/bootstrapping-vs-venture-capital/',
          duration: '10 min read'
        },
        {
          title: 'How Startups Actually Fail',
          description: 'Common reasons startups shut down.',
          type: 'article',
          url: 'https://www.cbinsights.com/research/startup-failure-reasons-top/',
          duration: '8 min read'
        },
        {
          title: 'What Is Product-Market Fit?',
          description: 'Understanding demand and customer validation.',
          type: 'article',
          url: 'https://a16z.com/what-is-product-market-fit/',
          duration: '6 min read'
        },
        {
          title: 'Marketing on a Zero Budget',
          description: 'Growth strategies for early-stage businesses.',
          type: 'article',
          url: 'https://www.shopify.com/blog/marketing-on-a-budget',
          duration: '9 min read'
        },
        {
          title: 'How Founders Pay Themselves',
          description: 'Founder compensation explained.',
          type: 'article',
          url: 'https://www.ycombinator.com/library/4A-how-founders-pay-themselves',
          duration: '6 min read'
        }
      ],
      
      videos: [
        {
          title: 'Startup School – Y Combinator',
          description: 'Foundational startup lessons from YC.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=6DFh7z7cYDU',
          duration: '1 hour'
        },
        {
          title: 'How to Start a Startup',
          description: 'Stanford lecture series with Sam Altman.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=CBYhVcO4WgI',
          duration: '50 min'
        },
        {
          title: 'Building a Business from $0',
          description: 'Alex Hormozi on starting and scaling businesses.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=Fzk5v5Zc8W4',
          duration: '30 min'
        },
        {
          title: 'Product-Market Fit Explained',
          description: 'Practical explanation for founders.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=MnP7jE6BbNc',
          duration: '18 min'
        },
        {
          title: 'How Founders Think',
          description: 'Naval Ravikant on leverage, wealth, and business.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=HiYo14wylQw',
          duration: '20 min'
        },
        {
          title: 'Marketing Strategies That Actually Work',
          description: 'Modern growth insights for entrepreneurs.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=9KaZL0zMbxg',
          duration: '22 min'
        }
      ],
      
  },

  // 3. HEALTHCARE & MEDICAL FIELD
  [toSlug('Healthcare & Medical Field')]: {
    title: 'Healthcare & Medical Field',
    fullTitle: 'Healthcare & Medical Career Path',
    description: 'Explore nursing, public health, clinical research, and allied health careers.',
    icon: MedicalGif,
    resources: [
        {
          title: 'Anatomy & Physiology – Khan Academy',
          description: 'Foundational human biology and body systems.',
          type: 'course',
          url: 'https://www.khanacademy.org/science/ap-biology',
          duration: 'Self-paced'
        },
        {
          title: 'CDC Public Health 101',
          description: 'Introduction to public health systems and population health.',
          type: 'course',
          url: 'https://www.cdc.gov/training/public-health-101/index.html',
          duration: '8 hours'
        },
        {
          title: 'Introduction to Clinical Research – NIH',
          description: 'Learn the basics of clinical trials and medical research.',
          type: 'course',
          url: 'https://www.training.nih.gov/course/index.php?categoryid=12',
          duration: 'Self-paced'
        },
        {
          title: 'Medical Terminology Course',
          description: 'Essential medical language for healthcare professionals.',
          type: 'course',
          url: 'https://www.coursera.org/learn/medical-terminology',
          duration: '4 weeks'
        },
        {
          title: 'WHO Open Learning Platform',
          description: 'Global health topics including infectious disease and emergency response.',
          type: 'website',
          url: 'https://openwho.org/',
          duration: null
        },
        {
          title: 'Allied Health Careers Guide',
          description: 'Explore careers like radiology, respiratory therapy, and lab science.',
          type: 'website',
          url: 'https://explorehealthcareers.org/',
          duration: null
        }
      ],
      
      articles: [
        {
          title: 'How to Become a Nurse',
          description: 'Career paths, education, and licensing explained.',
          type: 'article',
          url: 'https://www.registerednursing.org/how-to-become-a-nurse/',
          duration: '10 min read'
        },
        {
          title: 'Healthcare Careers Explained',
          description: 'Overview of major healthcare professions.',
          type: 'article',
          url: 'https://www.bls.gov/ooh/healthcare/home.htm',
          duration: '8 min read'
        },
        {
          title: 'Public Health vs Clinical Medicine',
          description: 'Comparing population health and patient care.',
          type: 'article',
          url: 'https://www.snhu.edu/about-us/newsroom/health/public-health-vs-medicine',
          duration: '6 min read'
        },
        {
          title: 'How to Work in Clinical Research',
          description: 'Roles and education in medical research.',
          type: 'article',
          url: 'https://www.nih.gov/health-information/nih-clinical-research-trials-you',
          duration: '7 min read'
        },
        {
          title: 'Healthcare Jobs with the Fastest Growth',
          description: 'High-demand roles and salary outlook.',
          type: 'article',
          url: 'https://www.bls.gov/ooh/fastest-growing.htm',
          duration: '6 min read'
        }
      ],
      
      videos: [
        {
          title: 'Medical Careers Explained',
          description: 'Overview of healthcare roles.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=3Q3v9y9S8tM',
          duration: '20 min'
        },
        {
          title: 'A Day in the Life of a Nurse',
          description: 'Realistic look at nursing responsibilities.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=ZCwjk1ZyJgE',
          duration: '12 min'
        },
        {
          title: 'What Is Public Health?',
          description: 'Public health fundamentals explained.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=BW7Gs5G5n3E',
          duration: '10 min'
        },
        {
          title: 'Clinical Research Careers',
          description: 'Overview of roles in medical research.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=_0Tg7xzV6m8',
          duration: '18 min'
        },
        {
          title: 'Allied Health Careers Overview',
          description: 'Exploring non-physician healthcare roles.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=Y9U2u4b6PZI',
          duration: '15 min'
        }
      ],
      
  },

  // 4. CREATIVE ARTS & DESIGN
  [toSlug('Creative Arts & Design')]: {
    title: 'Creative Arts & Design',
    description: 'Graphic design, UX/UI, illustration, and visual creativity.',
    icon: CreativeGif,
    resources: [
        {
          title: 'Graphic Design Basics – Coursera',
          description: 'Fundamentals of design principles and visual hierarchy.',
          type: 'course',
          url: 'https://www.coursera.org/learn/fundamental-design',
          duration: '4 weeks'
        },
        {
          title: 'Google UX Design Certificate',
          description: 'Industry-recognized certificate covering UX research, wireframes, and prototyping.',
          type: 'certificate',
          url: 'https://www.coursera.org/professional-certificates/google-ux-design',
          duration: '6 months'
        },
        {
          title: 'Figma Learn Design',
          description: 'Official tutorials for mastering Figma design and collaboration.',
          type: 'course',
          url: 'https://help.figma.com/hc/en-us/articles/360040514273-Learn-design-with-Figma',
          duration: 'Self-paced'
        },
        {
          title: 'Adobe Creative Cloud Tutorials',
          description: 'Learn Photoshop, Illustrator, After Effects, and more.',
          type: 'website',
          url: 'https://helpx.adobe.com/tutorials.html',
          duration: null
        },
        {
          title: 'Canva Design School',
          description: 'Beginner-friendly visual design lessons.',
          type: 'course',
          url: 'https://www.canva.com/designschool/',
          duration: 'Self-paced'
        },
        {
          title: 'UX/UI Portfolio Guide',
          description: 'How to build a professional design portfolio.',
          type: 'website',
          url: 'https://uxfolio.com/portfolio-advice',
          duration: null
        }
      ],
      
      articles: [
        {
          title: 'What Is UX Design?',
          description: 'Core UX design principles and process.',
          type: 'article',
          url: 'https://www.interaction-design.org/literature/topics/ux-design',
          duration: '8 min read'
        },
        {
          title: 'Graphic Designer vs UX Designer',
          description: 'Key differences between creative career paths.',
          type: 'article',
          url: 'https://careerfoundry.com/en/blog/ux-design/graphic-design-vs-ux-design/',
          duration: '6 min read'
        },
        {
          title: 'How to Build a Design Portfolio',
          description: 'What recruiters look for in creative portfolios.',
          type: 'article',
          url: 'https://www.smashingmagazine.com/2019/01/how-to-create-ux-portfolio/',
          duration: '10 min read'
        },
        {
          title: 'Principles of Visual Design',
          description: 'Color, typography, contrast, and layout fundamentals.',
          type: 'article',
          url: 'https://www.canva.com/learn/principles-of-design/',
          duration: '7 min read'
        },
        {
          title: 'Careers in Creative Design',
          description: 'Salary, roles, and job outlook for designers.',
          type: 'article',
          url: 'https://www.bls.gov/ooh/arts-and-design/home.htm',
          duration: '5 min read'
        }
      ],
      
      videos: [
        {
          title: 'Figma UI Design Tutorial',
          description: 'Design modern interfaces using Figma.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=FTFaQWZBqQ8',
          duration: '2 hours'
        },
        {
          title: 'UX Design Process Explained',
          description: 'From research to final prototype.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=Ovj4hFxko7c',
          duration: '15 min'
        },
        {
          title: 'How to Become a Graphic Designer',
          description: 'Career advice for aspiring designers.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=ZK86XQ1Kp9E',
          duration: '18 min'
        },
        {
          title: 'Design Thinking Explained',
          description: 'IDEO-style design thinking fundamentals.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=_r0VX-aU_T8',
          duration: '12 min'
        },
        {
          title: 'Day in the Life of a UX Designer',
          description: 'Behind-the-scenes of UX work.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=9Wu1tYdZ7Dg',
          duration: '10 min'
        },
        {
          title: 'How Designers Get Clients',
          description: 'Freelancing, pricing, and contracts.',
          type: 'video',
          url: 'https://www.youtube.com/watch?v=T0nPb7FncZ0',
          duration: '14 min'
        }
      ],
      
  },
// 5. CONTENT CREATION & MEDIA
[toSlug('Content Creation & Media')]: {
    title: 'Content Creation & Media',
    description: 'Video production, podcasting, writing, and social media.',
    icon: ContentGif,
    resources: [
        {
          title: 'YouTube Creator Academy',
          description: 'Official training for growing YouTube channels, understanding analytics, and increasing engagement.',
          type: 'course',
          url: 'https://creatoracademy.youtube.com',
          duration: 'Self-paced'
        },
        {
          title: 'TikTok Creative Center',
          description: 'Learn how TikTok trends, ads, and viral content are created.',
          type: 'website',
          url: 'https://www.tiktok.com/business/creativecenter',
          duration: null
        },
        {
          title: 'Twitch Creator Camp',
          description: 'Official Twitch resource for new and growing streamers.',
          type: 'course',
          url: 'https://www.twitch.tv/creatorcamp',
          duration: 'Self-paced'
        },
        {
          title: 'Spotify for Podcasters Academy',
          description: 'Guides for launching, growing, and monetizing a podcast.',
          type: 'course',
          url: 'https://podcasters.spotify.com/learn',
          duration: 'Self-paced'
        },
        {
          title: 'Canva Design School',
          description: 'Learn graphic design, thumbnails, and branding for creators.',
          type: 'course',
          url: 'https://www.canva.com/designschool/',
          duration: 'Self-paced'
        },
        {
          title: 'Pat Flynn – Smart Passive Income',
          description: 'Creator monetization, content strategy, and online business education.',
          type: 'website',
          url: 'https://www.smartpassiveincome.com/',
          duration: null
        },
        {
          title: 'Colin & Samir Creator Economy Hub',
          description: 'Deep dives into the creator economy, brand deals, and platform strategy.',
          type: 'website',
          url: 'https://www.colinandsamir.com/',
          duration: null
        },
        {
          title: 'HubSpot Content Marketing Certification',
          description: 'Learn content strategy, storytelling, and distribution.',
          type: 'course',
          url: 'https://academy.hubspot.com/courses/content-marketing',
          duration: '6 hours'
        }
      ],
      articles: [
        {
          title: 'How to Monetize Content',
          description: 'Ways to generate income as a creator across multiple platforms.',
          type: 'article',
          url: 'https://blog.hubspot.com/marketing/content-monetization',
          duration: '7 min read'
        },
        {
          title: 'How YouTubers Make Money',
          description: 'Ad revenue, sponsorships, merch, and memberships explained.',
          type: 'article',
          url: 'https://www.shopify.com/blog/how-youtubers-make-money',
          duration: '8 min read'
        },
        {
          title: 'Creator Economy Explained',
          description: 'Understanding the business of being a content creator.',
          type: 'article',
          url: 'https://www.forbes.com/sites/forbesbusinesscouncil/2023/05/15/the-creator-economy-explained/',
          duration: '6 min read'
        },
        {
          title: 'How the YouTube Algorithm Works',
          description: 'Official insights on recommendations and discovery.',
          type: 'article',
          url: 'https://support.google.com/youtube/answer/141805',
          duration: '6 min read'
        },
        {
          title: 'How to Grow an Audience from Zero',
          description: 'Actionable strategies for new creators.',
          type: 'article',
          url: 'https://convertkit.com/grow-your-audience',
          duration: '9 min read'
        },
        {
          title: 'Brand Deals for Creators: How It Works',
          description: 'How influencers get paid partnerships and sponsorships.',
          type: 'article',
          url: 'https://later.com/blog/influencer-marketing/',
          duration: '8 min read'
        },
        {
          title: 'Short-Form Video Strategy',
          description: 'TikTok, Reels, and Shorts growth strategies.',
          type: 'article',
          url: 'https://later.com/blog/tiktok-algorithm/',
          duration: '7 min read'
        }
      ],
      
    videos: [
      {
        title: 'Podcasting for Beginners',
        description: 'Start your first podcast.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=Z0V68b6EJwQ',
        duration: '25 min'
      },
      {
        title: 'How I Built a YouTube Empire',
        description: 'MrBeast explains how he approaches content, thumbnails, retention, and scaling channels.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=J7GY1Xg6X20',
        duration: '15 min'
      },
      {
        title: 'How to Grow on YouTube in 2024',
        description: 'Think Media breaks down YouTube algorithm, consistency, and niche selection.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=ShO9S8FjGxQ',
        duration: '18 min'
      },
      {
        title: 'The Future of Content Creation',
        description: 'Gary Vaynerchuk talks about short-form content, personal branding, and attention.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=GvXzG2B2H0Y',
        duration: '22 min'
      },
      {
        title: 'How I Edit Viral YouTube Videos',
        description: 'Ali Abdaal explains editing workflow, pacing, and storytelling.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=PCN9v6x5Njo',
        duration: '30 min'
      },
      {
        title: 'How Streamers Actually Make Money',
        description: 'Harris Heller (Senpai Gaming) breaks down Twitch & YouTube monetization.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=6B5pI5ZC3G8',
        duration: '20 min'
      },
      {
        title: 'How I Grew on Twitch from Zero',
        description: 'Ludwig explains discoverability, consistency, and audience building.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=0i9gkprYekI',
        duration: '14 min'
      },
      {
        title: 'Podcasting: How to Start & Scale',
        description: 'Pat Flynn breaks down podcast growth and monetization.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=cHn1VQwDJX8',
        duration: '27 min'
      },
      {
        title: 'Short-Form Content Strategy (TikTok, Reels)',
        description: 'Colin & Samir talk creator economy and short-form growth.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=7z2B1o_fGZQ',
        duration: '35 min'
      },
      {
        title: 'Day in the Life of a Full-Time YouTuber',
        description: 'Casey Neistat shares behind-the-scenes of content creation lifestyle.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=nfs8NYg7yQM',
        duration: '10 min'
      }
    ]
  },
  

  // 7. SKILLED TRADES
  [toSlug('Skilled Trades')]: {
    title: 'Skilled Trades',
    description: 'Electrician, plumbing, HVAC, welding, and hands-on careers in high demand.',
    icon: TradesGif,
    resources: [
      {
        title: 'OSHA Safety Training',
        description: 'Workplace safety fundamentals for trade professionals.',
        type: 'course',
        url: 'https://www.osha.gov/training',
        duration: '10–30 hours'
      },
      {
        title: 'Electrician Apprenticeship Guide',
        description: 'Learn how to enter and succeed in electrician apprenticeships.',
        type: 'website',
        url: 'https://www.electricianapprenticehq.com/',
        duration: null
      },
      {
        title: 'HVAC Training Program Overview',
        description: 'Explore HVAC education and certifications.',
        type: 'website',
        url: 'https://www.hvactraining101.com/',
        duration: null
      },
      {
        title: 'Welding Certification Guide',
        description: 'Paths to becoming a certified welder.',
        type: 'article',
        url: 'https://www.thefabricator.com/thewelder/article/education/certifications-for-welders',
        duration: '6 min read'
      }
    ],
    articles: [
      {
        title: 'How to Become an Electrician',
        description: 'Training, pay, and certification paths.',
        type: 'article',
        url: 'https://www.indeed.com/career-advice/finding-a-job/how-to-become-an-electrician',
        duration: '8 min read'
      },
      {
        title: 'Highest Paying Skilled Trades',
        description: 'Top trades ranked by salary and demand.',
        type: 'article',
        url: 'https://www.trade-schools.net/articles/highest-paying-skilled-trades',
        duration: '7 min read'
      },
      {
        title: 'Apprenticeship vs Trade School',
        description: 'Which path is right for skilled trades?',
        type: 'article',
        url: 'https://www.careeronestop.org/Toolkit/Training/apprenticeships.aspx',
        duration: '6 min read'
      }
    ],
    videos: [
      {
        title: 'HVAC Basics',
        description: 'Introduction to heating and cooling systems.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=68z2aP4KGHU',
        duration: '20 min'
      },
      {
        title: 'A Day in the Life of an Electrician',
        description: 'Real-world electrician work experience.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=U2boJ3QxJHg',
        duration: '12 min'
      },
      {
        title: 'Skilled Trades Explained',
        description: 'Why trades are in high demand.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=JpKjC-DzGjk',
        duration: '15 min'
      }
    ]
  },
  

  // 8. EDUCATION & TEACHING
  [toSlug('Education & Teaching')]: {
    title: 'Education & Teaching',
    description: 'Teaching methods, curriculum design, and education leadership careers.',
    icon: EducationGif,
    resources: [
      {
        title: 'Teaching Strategies – EdX',
        description: 'Learn modern instructional methods.',
        type: 'course',
        url: 'https://www.edx.org/learn/teaching',
        duration: '6 weeks'
      },
      {
        title: 'Google Certificate: Educational Technology',
        description: 'Using digital tools in modern classrooms.',
        type: 'course',
        url: 'https://grow.google/certificates/',
        duration: 'Self-paced'
      },
      {
        title: 'Teacher Certification Guide',
        description: 'State-by-state teacher certification paths.',
        type: 'website',
        url: 'https://www.teach.org/',
        duration: null
      }
    ],
    articles: [
      {
        title: 'How to Become a Teacher',
        description: 'Certification, degrees, and career steps.',
        type: 'article',
        url: 'https://www.teacher.org/',
        duration: '10 min read'
      },
      {
        title: 'Curriculum Design Explained',
        description: 'How effective learning programs are built.',
        type: 'article',
        url: 'https://www.edutopia.org/article/curriculum-design',
        duration: '7 min read'
      },
      {
        title: 'Education Careers Beyond Teaching',
        description: 'Administration, curriculum, and ed-tech roles.',
        type: 'article',
        url: 'https://www.bls.gov/ooh/education-training-and-library/home.htm',
        duration: '6 min read'
      }
    ],
    videos: [
      {
        title: 'Classroom Management Tips',
        description: 'Effective classroom strategies.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=7qblDR8XUgk',
        duration: '15 min'
      },
      {
        title: 'Day in the Life of a Teacher',
        description: 'What teaching really looks like.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=5P6eYJkLooA',
        duration: '10 min'
      },
      {
        title: 'How to Be a Great Teacher',
        description: 'Engagement, motivation, and growth.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=VrZ4s1E1YpI',
        duration: '14 min'
      }
    ]
  },
  
  // 9. ENVIRONMENTAL SCIENCE
  [toSlug('Environmental Science')]: {
    title: 'Environmental Science',
    description: 'Sustainability, climate science, conservation, and environmental policy.',
    icon: EnvironmentalGif,
    resources: [
      {
        title: 'Environmental Science – Coursera',
        description: 'Foundational environmental science concepts.',
        type: 'course',
        url: 'https://www.coursera.org/learn/environmental-science',
        duration: '6 weeks'
      },
      {
        title: 'NASA Climate Change Resources',
        description: 'Climate science and real-world data.',
        type: 'website',
        url: 'https://climate.nasa.gov/',
        duration: null
      },
      {
        title: 'Sustainability Careers Guide',
        description: 'Careers in renewable energy and conservation.',
        type: 'website',
        url: 'https://www.environmentalscience.org/careers',
        duration: null
      }
    ],
    articles: [
      {
        title: 'What Is Climate Change?',
        description: 'Scientific overview from NASA.',
        type: 'article',
        url: 'https://climate.nasa.gov/',
        duration: '5 min read'
      },
      {
        title: 'Environmental Science Careers',
        description: 'Education, salary, and outlook.',
        type: 'article',
        url: 'https://www.bls.gov/ooh/life-physical-and-social-science/home.htm',
        duration: '6 min read'
      },
      {
        title: 'What Is Sustainability?',
        description: 'Core pillars of sustainability.',
        type: 'article',
        url: 'https://www.un.org/sustainabledevelopment/',
        duration: '6 min read'
      }
    ],
    videos: [
      {
        title: 'Sustainability Explained',
        description: 'Understanding sustainability.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=JYq6UU5yL8g',
        duration: '10 min'
      },
      {
        title: 'Climate Change Explained',
        description: 'How climate change impacts the world.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=ifrHogDujXw',
        duration: '12 min'
      }
    ]
  },
  

  // 10. CULINARY ARTS & HOSPITALITY
  [toSlug('Culinary Arts & Hospitality')]: {
    title: 'Culinary Arts & Hospitality',
    description: 'Cooking, baking, restaurant management, and hospitality leadership.',
    icon: CulinaryGif,
    resources: [
      {
        title: 'Culinary Techniques – Rouxbe',
        description: 'Professional culinary training.',
        type: 'course',
        url: 'https://rouxbe.com/',
        duration: 'Self-paced'
      },
      {
        title: 'Restaurant Management Fundamentals',
        description: 'Learn operations, staffing, and food costs.',
        type: 'course',
        url: 'https://www.coursera.org/learn/restaurant-management',
        duration: '4 weeks'
      },
      {
        title: 'Hospitality Career Guide',
        description: 'Hotel, travel, and service careers.',
        type: 'website',
        url: 'https://www.ehl.edu/career-development',
        duration: null
      }
    ],
    articles: [
      {
        title: 'How to Become a Chef',
        description: 'Career guide for chefs.',
        type: 'article',
        url: 'https://www.careerschoolnow.org/career/how-to-become-a-chef/',
        duration: '8 min read'
      },
      {
        title: 'Restaurant Career Paths',
        description: 'From line cook to executive chef.',
        type: 'article',
        url: 'https://www.webstaurantstore.com/article/22/restaurant-careers.html',
        duration: '6 min read'
      }
    ],
    videos: [
      {
        title: 'Knife Skills 101',
        description: 'Essential kitchen skills.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=G-Fg7l7G1zw',
        duration: '15 min'
      },
      {
        title: 'Day in the Life of a Chef',
        description: 'Behind-the-scenes kitchen life.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=5xZyA0OJVcI',
        duration: '12 min'
      }
    ]
  },
  

  // 11. LAW & JUSTICE
  [toSlug('Law & Justice')]: {
    title: 'Law & Justice',
    description: 'Legal studies, criminal justice, paralegal work, and public service.',
    icon: LawGif,
    resources: [
      {
        title: 'Introduction to American Law',
        description: 'Foundations of the U.S. legal system.',
        type: 'course',
        url: 'https://www.coursera.org/learn/american-law',
        duration: '6 weeks'
      },
      {
        title: 'Criminal Justice Program Overview',
        description: 'Understanding law enforcement and justice careers.',
        type: 'website',
        url: 'https://www.criminaljusticedegreehub.com/',
        duration: null
      },
      {
        title: 'LSAT Prep (Free)',
        description: 'Introduction to law school admission.',
        type: 'course',
        url: 'https://www.khanacademy.org/test-prep/lsat',
        duration: 'Self-paced'
      }
    ],
    articles: [
      {
        title: 'Paralegal Career Guide',
        description: 'Education and job outlook.',
        type: 'article',
        url: 'https://www.bls.gov/ooh/legal/paralegals-and-legal-assistants.htm',
        duration: '10 min read'
      },
      {
        title: 'Careers in Criminal Justice',
        description: 'Police, corrections, and federal roles.',
        type: 'article',
        url: 'https://www.bls.gov/ooh/protective-service/home.htm',
        duration: '8 min read'
      },
      {
        title: 'Law School vs Legal Careers',
        description: 'Do you need law school?',
        type: 'article',
        url: 'https://www.usnews.com/education/blogs/law-admissions-lowdown',
        duration: '6 min read'
      }
    ],
    videos: [
      {
        title: 'Criminal Justice Explained',
        description: 'Overview of the justice system.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=wW4gIYy5XwQ',
        duration: '22 min'
      },
      {
        title: 'Day in the Life of a Paralegal',
        description: 'What paralegals actually do.',
        type: 'video',
        url: 'https://www.youtube.com/watch?v=YtC6P8wL8R0',
        duration: '12 min'
      }
    ]
  },
  
};

const ALL_CATEGORIES = Object.keys(PATH_ROADMAPS).map(slug => ({
  title: PATH_ROADMAPS[slug].title,
  description: PATH_ROADMAPS[slug].description,
  icon: PATH_ROADMAPS[slug].icon,
  slug
}));

export { PATH_ROADMAPS, ALL_CATEGORIES, toSlug };
